import { Check } from "lucide-react";
import { STEPS } from "./constants";

export default function Stepper({ step, maxStep, onGo }) {
  return (
    <nav aria-label="CV Studio progress" data-testid="studio-stepper" className="mb-8">
      <div className="flex items-center justify-between text-sm mb-2 sm:hidden">
        <span className="font-semibold text-ink">Step {step} of 6 · {STEPS[step - 1].label}</span>
        <span className="text-faint">{Math.round((step / 6) * 100)}%</span>
      </div>
      <div className="h-1.5 rounded-full bg-subtle overflow-hidden sm:hidden" aria-hidden="true">
        <div className="h-full bg-brand rounded-full transition-[width] duration-500" style={{ width: `${(step / 6) * 100}%` }} />
      </div>
      <ol className="hidden sm:flex items-center gap-2">
        {STEPS.map((s, i) => {
          const done = s.n < step, cur = s.n === step, reachable = s.n <= maxStep;
          return (
            <li key={s.n} className="flex items-center gap-2 flex-1 min-w-0">
              <button data-testid={`studio-step-${s.n}`} disabled={!reachable} onClick={() => onGo(s.n)} aria-current={cur ? "step" : undefined}
                className={`flex items-center gap-2 min-w-0 rounded-lg px-1.5 py-1 -mx-1.5 transition-colors ${reachable && !cur ? "hover:bg-subtle" : ""} disabled:cursor-not-allowed`}>
                <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0 border ${cur ? "bg-brand text-onbrand border-brand" : done ? "bg-brand-soft text-brand-text border-brand/30" : "bg-surface text-faint border-line-strong/50"}`}>
                  {done ? <Check className="w-3.5 h-3.5" aria-hidden="true" /> : s.n}
                </span>
                <span className={`text-sm leading-tight text-left ${cur ? "font-semibold text-ink" : reachable ? "text-body" : "text-faint"}`}>{s.label}</span>
              </button>
              {i < STEPS.length - 1 && <span className={`h-px flex-1 min-w-[12px] ${done ? "bg-brand/40" : "bg-line"}`} aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export function StepNav({ onBack, onNext, nextLabel = "Continue", nextDisabled, busy, extra }) {
  return (
    <div className="sticky bottom-0 z-10 -mx-4 sm:-mx-8 lg:-mx-10 mt-8 px-4 sm:px-8 lg:px-10 pt-3 bg-surface/95 backdrop-blur border-t border-line pb-safe-bar">
      <div className="flex flex-wrap items-center gap-3">
        {onBack && <button data-testid="studio-back-button" onClick={onBack} className="gi-btn gi-btn-secondary">Back</button>}
        {extra}
        {onNext && (
          <button data-testid="studio-next-button" onClick={onNext} disabled={nextDisabled || busy} className="gi-btn gi-btn-primary flex-1 min-w-[180px] sm:flex-none sm:ml-auto">
            {nextLabel}
          </button>
        )}
      </div>
    </div>
  );
}
